module.exports = __webpack_public_path__ + "static/img/demo-start.69f2dba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/demo-start.png
// module id = D4gs
// module chunks = 0